// src/pages/Consultation/index.js
import React from "react";
import { Routes, Route } from "react-router-dom";
import ConsultationDashboard from "./ConsultationDashboard";
import SessionDetail from "./SessionDetail/SessionDetail";
import StartSessionPage from "./StartSessionPage";

const ConsultationRoutes = () => {
  return (
    <Routes>
      <Route path="/" element={<ConsultationDashboard />} />
      <Route path="/start-session" element={<StartSessionPage />} />
      <Route path="/sessions/:sessionId" element={<SessionDetail />} />
    </Routes>
  );
};

export default ConsultationRoutes;
